import dayjs from 'dayjs';
import { IAuditorium } from '../../../shows/core/interfaces/IAuditoriums';
import { IShow } from '../../../shows/core/interfaces/IShow';

export class NextShowAfterSaleUtils {

  public static pickNextUpcomingShow(shows: IShow[], auditoriums: IAuditorium[]): IShow | null {
    const nowMs = Date.now();
    const auditoriumOrder = new Map(auditoriums.map((auditorium, index) => [auditorium.id, index]));

    const upcomingShows = shows.filter(show => {
      if (show.flagDeleted) {
        return false;
      }

      const startMs = new Date(show.beginning).getTime();

      return startMs >= nowMs;
    });

    if (upcomingShows.length === 0) {
      return null;
    }

    upcomingShows.sort((left, right) => {
      const startDiff = dayjs(left.beginning).valueOf() - dayjs(right.beginning).valueOf();

      if (startDiff !== 0) {
        return startDiff;
      }

      const leftAuditoriumOrder = auditoriumOrder.get(left.auditorium.id) ?? Number.MAX_SAFE_INTEGER;
      const rightAuditoriumOrder = auditoriumOrder.get(right.auditorium.id) ?? Number.MAX_SAFE_INTEGER;

      return leftAuditoriumOrder - rightAuditoriumOrder;
    });

    return upcomingShows[0];
  }
}
